var _ = require('underscore'),
    TaskPerms = require('./taskPermsModel.js'),
    UserGroups = require('./groups/userGroups.js'),
    fvChannel = require('glRadio').channel('FV'),
    PrivateGroups = require('./groups/privateGroups'),
    ReferralGroups = require('./groups/referralGroups'),
    Stamps = require('./stamps/myStamps');


/* Top Level Module: also contains groups, user groups, task permissions, referral groups, private groups, stamps */

module.exports = Backbone.Model.extend({

    initialize: function( attrs, options ) {

        this.taskPermissions = new TaskPerms(); //just an array stored in model attributes
        this.groups = new UserGroups();
        this.privateGroups = null;

        // ReferralGroups will be empty if error occurs fetching, and, in currently workflow, we won't be able to enter viewer
        // TODO: may want to handle this situation better ... eg: log an error handle as referralGroups don't exist
        this.referralGroups = options.fetchReferralGroups
            ? new ReferralGroups()
            : null; // serves as flag that system doesn't support (could be used instead of channel request)

        this.stamps = new Stamps();


    },

    url: function() {
       return fvChannel.request('apiUrl').user;
    },

    /* Get this model, taskPermissions, groups, referralGroups, -- done to allow entry -- disallow if all fails */
    fetchWithGroupsAndTaskPerms: function(cxt) {

        cxt = cxt ? cxt : this;

        var fetchReferralGroups = this.referralGroups !== null,
            $dfdUser = this.fetch(),
            $dfdTaskPerms = this.taskPermissions.fetch(),
            $dfdGroups = this.groups.fetch(),
            $dfdStamps = this.stamps.fetch(),
            $dfdReferralGroups = fetchReferralGroups
                ? this.referralGroups.fetch()
                : null,
            dfds = [$dfdUser, $dfdTaskPerms, $dfdGroups, $dfdStamps];

        fetchReferralGroups && ( dfds.push($dfdReferralGroups) );

        return $.Deferred(function($dfd) {

            $.when.apply($, dfds).done (function( user, taskPerms, groups, stamps, referralGroups ) { // jqXHRs are the args

                $dfd.resolveWith(cxt);

            }).fail(function(failJQXHR) { //called if any fail

                _.invoke(dfds, 'abort');

                var dfdFail = _.find(dfds, function($dfd) {
                   return $dfd === failJQXHR;
                });

                switch(dfdFail) {
                    case $dfdUser:
                        $dfd.rejectWith(cxt, ['User', failJQXHR]); break;
                    case $dfdTaskPerms:
                        $dfd.rejectWith(cxt, ['Task Permissions', failJQXHR]);  break;
                    case $dfdGroups:
                        $dfd.rejectWith(cxt, ['Groups', failJQXHR]);  break;
                    case $dfdReferralGroups:
                        $dfd.rejectWith(cxt, ['Referral Groups', failJQXHR]); break;
                    case $dfdStamps:
                        $dfd.rejectWith(cxt, ['Stamps', failJQXHR]); break;
                }
            });

        }).promise();

    },
    getUserDescription: function() {
        return this.get('description');
    },
    getUserID: function() {
        return this.get('userId');
    },
    /*
    * Note: note fetched on demand with flash notes and cached
    * Private groups should be a 'system resource ???
    * */
    gettingPrivateGroups: function() {

        var self = this;

        return $.Deferred(function($dfd) {

             if ( self.privateGroups )  { //(cached)

                $dfd.resolve(self.privateGroups);
            } else {

                self.privateGroups = new PrivateGroups();
                self.privateGroups.fetch().done( function(groups) {
                    $dfd.resolve(groups);
                }).fail(function(jqXHR) {
                    $dfd.reject(jqXHR);
                });
            }

        }).promise();

    },
    /* former: false if error */
    groupStatus: function() {

        return this.groups && this.groups.findWhere({ groupId: this.getUserID() }) &&
            this.groups.findWhere({ groupId: this.getUserID() }).get('status');

    },
    privateGroupsFetched: function() {
        return this.privateGroups !== null;
    },

    /* return the users private group model in the priv. grps collection */
    getPrivateGroup: function() {

        if ( !this.privateGroups ) {
            return false;
        }

        return this.privateGroups.findWhere( {groupId: this.get('privateGrpId') });

    },
    defaultNoteAccessGroup: function(isFlashNote) {
        /* other user id or private group */
        return {
            id: !isFlashNote ? 1 : 4, /* groups: groupId, name */
            name: !isFlashNote ? 'public' : 'fdd'
        };
    },

    /* -- Stamps Proxy -- */

    getStamps: function() {
        return this.stamps;
    },

    getGraphicStamps: function() {
        return this.getStamps().getGraphicStamps();
    },

    getTextStamps: function() {
        return this.getStamps().getTextStamps();
    },

    /* Note -- doesn't determine if stamps exist in the system -- just if the user does --
     * Potentially problematic if populating stamp note dropdown -- TODO: test if we add the preview from the note source here
     */
    hasGraphicStamps: function() {
        return this.getGraphicStamps().userHasStamps;
    },

    hasTextStamps: function() {
        return this.getTextStamps().userHasStamps;
    },


    /* -- End Stamps -- */


    getReferralGroups: function() {
        return this.referralGroups; // can be null if system doesn't support
    },

    getUserName: function() {
        return this.get('username');
    },

    getGroupOfDerivedUserColor: function() {
        return this.groups.getGroupOfDerivedUserColor();
    },

    getDerivedUserGroupColor: function() {
        return this.groups.getDerivedUserGroupColor();
    },

    /**
     * DVBC-1718 - reversing DVBC-1711 no longer used.
     */
    canViewPdfs: function() {
        return this.taskPermissions.canViewPdfs();
    },

    canExport: function() {
        return this.taskPermissions.canExport();
    },

    canPrint: function() {
        return this.taskPermissions.canPrint();
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/userModel.js
 ** module id = 82
 ** module chunks = 0
 **/